import { service } from '../index.js'

// 素材管理
export const material = {
  // 列表（后台）
  list: ({ params = {} } = {}) => {
    return service.get('/material/admin/list', { params })
  },
  
  // 详情
  get: (params) => {
    return service.get('/material/detail', { params })
  },
  
  // 保存（新增/编辑共用）
  save: (data) => {
    return service.post('/material/admin/save', data)
  },
  
  // 切换状态
  toggleStatus: (data) => {
    return service.post('/material/admin/toggle-status', data)
  },
  
  // 删除
  delete: (params) => {
    return service.post('/material/admin/delete', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/material.js